import { render } from "./ModalPending.vue?vue&type=template&id=2bfafe4c"
import script from "./ModalPending.vue?vue&type=script&lang=js"
export * from "./ModalPending.vue?vue&type=script&lang=js"

import "./ModalPending.vue?vue&type=style&index=0&id=2bfafe4c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__